import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function Countdown() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  const blocks = [{
    value: pad(hours),
    label: 'Horas'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Seg'
  }];
  return <div className="w-full max-w-md mx-auto rounded-2xl border border-alert-500/30 bg-alert-500/[0.06] px-4 py-4" data-id="element-18" data-mp="374mby6r15h6j">
      <p className="flex items-center justify-center gap-2 text-[11.5px] sm:text-xs font-bold uppercase tracking-[0.14em] text-alert-600 text-center" data-id="element-19" data-mp="15b68uadra9uo">
        <TimerIcon className="w-4 h-4" aria-hidden="true" data-id="element-20" data-mp="xzlr5mnkwqtw" />
        Esta oferta expira en
      </p>
      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-21" data-mp="t1k6ixai8jgb">
        {blocks.map((b, i) => <React.Fragment key={b.label} data-id="element-22" data-mp="17q6mn17yhf8l" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-23" data-mp="12s55ilu3bpzr">
              <span className="w-[62px] sm:w-[70px] rounded-xl bg-navy-800 py-2 text-center font-display text-2xl sm:text-3xl font-bold tabular-nums text-white" aria-hidden={false} data-id="element-24" data-mp="12solvy43e6bo">
                {b.value}
              </span>
              <span className="mt-1 text-[10px] font-semibold uppercase tracking-widest text-navy-600/70" data-id="element-25" data-mp="o3s59cnyzkzg">
                {b.label}
              </span>
            </div>
            {i < blocks.length - 1 && <span className="pb-4 font-display text-2xl font-bold text-navy-600/40" data-id="element-26" data-mp="1zgkvuk50y3dx">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}